import { render } from "./LoadingReport.vue?vue&type=template&id=60181b4a"
import script from "./LoadingReport.vue?vue&type=script&lang=js"
export * from "./LoadingReport.vue?vue&type=script&lang=js"

import "./LoadingReport.vue?vue&type=style&index=0&id=60181b4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__